export default "__VITE_ASSET__yhgjmM6y__"